<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main>
      <div class="zj-layout-main-content scrollable">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem" style="max-width:120rem;">
          <el-form-item label></el-form-item>
          <el-form-item label="队伍名称" prop="RescourceName">
            <el-input v-model="ruleForm.RescourceName" style="width:98rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="队伍归属" prop="TeamOwnership" style="display:inline-block;">
            <el-radio-group
              v-model="ruleForm.TeamOwnership"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            >
              <el-radio
                v-for="item in TeamOwnershipoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="队伍类型" prop="TeamType" style="display:inline-block;">
            <el-select
              v-model="ruleForm.TeamType"
              placeholder="请选择队伍类型"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否具有资质" prop="IsHaveCertificate" style="display:inline-block;">
            <el-select
              v-model="ruleForm.IsHaveCertificate"
              placeholder="请选择是否具有资质"
              v-bind:disabled="IsEdit"
              style="width:40rem;"
            >
              <el-option
                v-for="item in IsHaveCertificateoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成立时间" prop="FoundTime" style="display:inline-block;">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.FoundTime"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="详细地址" prop="Address" style="display:inline-block;">
            <el-input v-model="ruleForm.Address" style="width:98rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="经度" prop="Longitude" style="display:inline-block;">
            <el-input v-model="ruleForm.Longitude" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="Latitude" style="display:inline-block;">
            <el-input v-model="ruleForm.Latitude" style="width:35rem;" v-bind:disabled="IsEdit"></el-input>
            <ZjLngLatSelect
              :point_lat="ruleForm.Latitude"
              :point_lng="ruleForm.Longitude"
              :disabled="IsEdit"
              @onGotLngLat="onGotLngLat"
              style="margin-left:0.5rem"
            ></ZjLngLatSelect>
          </el-form-item>
          <el-form-item label="队伍等级" prop="TeamLevel" style="display:inline-block;">
            <el-select
              v-model="ruleForm.TeamLevel"
              style="width:40rem;"
              placeholder="请选择队伍等级"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options2"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务区域" prop="ServiceArea" style="display:inline-block;">
            <el-input v-model="ruleForm.ServiceArea" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="总人数" prop="Total" style="display:inline-block;">
            <el-input v-model="ruleForm.Total" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="指战人数" prop="CommanderNum" style="display:inline-block;">
            <el-input v-model="ruleForm.CommanderNum" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="擅长事故类型" prop="EmergencyType" style="display:inline-block;">
            <el-select
              v-model="ruleForm.EmergencyType"
              style="width:40rem;"
              placeholder="请选择擅长事故类型"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options3"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆数" prop="CarNum" style="display:inline-block;">
            <el-input v-model="ruleForm.CarNum" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="专长描述" prop="SkillDesc">
            <el-input
              type="textarea"
              style="width:98rem;"
              v-model="ruleForm.SkillDesc"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="主要装备描述" prop="EquipDesc">
            <el-input
              type="textarea"
              style="width:98rem;"
              v-model="ruleForm.EquipDesc"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="Contact" style="display:inline-block;">
            <el-input v-model="ruleForm.Contact" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="负责人移动电话" prop="ContactMobilePhone" style="display:inline-block;">
            <el-input
              v-model="ruleForm.ContactMobilePhone"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人固定电话" prop="ContactFixPhone" style="display:inline-block;">
            <el-input v-model="ruleForm.ContactFixPhone" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="应急值班电话" prop="DutyPhone" style="display:inline-block;">
            <el-input v-model="ruleForm.DutyPhone" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="分管领导" prop="LeaderName" style="display:inline-block;">
            <el-input v-model="ruleForm.LeaderName" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="分管领导移动电话" prop="LeaderMobilePhone" style="display:inline-block;">
            <el-input
              v-model="ruleForm.LeaderMobilePhone"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="分管领导固定电话" prop="LeaderFixPhone" style="display:inline-block;">
            <el-input v-model="ruleForm.LeaderFixPhone" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Remark" style="display:inline-block;">
            <el-input
              type="textarea"
              style="width:98rem;"
              v-model="ruleForm.Remark"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="width:116rem; text-align:center;margin:1rem 1rem;padding-left:16rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm('')" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjResourcesTeaminfo",
  controller: "EmergencyResource",
  action: "ResourcesTeaminfo",
  props: {
    query: {
      type: String,
      obj: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      ruleForm: {
        RescourceName: "",
        TeamOwnership: "",
        TeamType: "",
        IsHaveCertificate: "",
        FoundTime: null,
        Address: "",
        Longitude: "",
        Latitude: "",
        TeamLevel: "",
        ServiceArea: "",
        Total: 0,
        CommanderNum: 0,
        EmergencyType: "",
        CarNum: 0,
        SkillDesc: "",
        EquipDesc: "",
        Contact: "",
        ContactMobilePhone: "",
        ContactFixPhone: "",
        DutyPhone: "",
        LeaderName: "",
        LeaderMobilePhone: "",
        LeaderFixPhone: "",
        Remark: ""
      },
      options: [],
      options2: [],
      options3: [],
      IsHaveCertificateoptions: [
        { value: 1, label: "是" },
        { value: 2, label: "否" }
      ],
      TeamOwnershipoptions: [
        { value: "1", label: "内部队伍" },
        { value: "2", label: "外部队伍" }
      ],
      rules: {
        RescourceName: [
          { required: true, message: "请输入队伍名称", trigger: "blur" }
        ],
        TeamOwnership: [
          { required: true, message: "请选择队伍归属", trigger: "charge" }
        ],
        IsHaveCertificate: [
          { required: true, message: "请选择是否具有资质", trigger: "charge" }
        ],
        Address: [{ required: true, message: "请选择地址", trigger: "blur" }],
        Longitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        Latitude: [
          { required: true, message: "请选择经纬度", trigger: "blur" }
        ],
        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          RescourceName: "",
          TeamOwnership: "",
          TeamType: "",
          IsHaveCertificate: "",
          FoundTime: null,
          Address: "",
          Longitude: "",
          Latitude: "",
          TeamLevel: "",
          ServiceArea: "",
          Total: 0,
          CommanderNum: 0,
          EmergencyType: "",
          CarNum: 0,
          SkillDesc: "",
          EquipDesc: "",
          Contact: "",
          ContactMobilePhone: "",
          ContactFixPhone: "",
          DutyPhone: "",
          LeaderName: "",
          LeaderMobilePhone: "",
          LeaderFixPhone: "",
          Remark: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        this.config.getUValue("EmergencyService:EmergencyType:", ""),
        this.config.getUValue("EmergencyService:TeamLevel:", ""),
        this.config.getUValue("EmergencyService:TeamType:", "")
      ])
      .then(r => {
        //擅长事故类型
        this.options3 = r[0].JValue;

        //队伍等级
        this.options2 = r[1].JValue;

        //队伍类型
        this.options = r[2].JValue;

        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.loading = false;
      });
    },
    search() {
      let RecordId = this.query.obj;
      if (RecordId != null && RecordId != "") {
        let searchInfo = {
          RecordId: RecordId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        this.loading = true;
        this.loadingText = '加载中...';
        new MyApis.RescourseTeamApi()
          .GetItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            //console.log(r);
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat;
      this.ruleForm.Longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm(formName) {
      this.ruleForm = formName;
      //this.$refs[formName].resetFields();
      this.query.obj = null;
    },
    save() {
      this.ruleForm.Longitude = parseFloat(this.ruleForm.Longitude); //
      this.ruleForm.Latitude = parseFloat(this.ruleForm.Latitude);
      this.ruleForm.IsHaveCertificate = parseInt(
        this.ruleForm.IsHaveCertificate
      );
      this.ruleForm.CommanderNum = parseInt(this.ruleForm.CommanderNum);
      this.ruleForm.CarNum = parseInt(this.ruleForm.CarNum);
      this.ruleForm.Total = parseInt(this.ruleForm.Total);
      this.ruleForm.TeamOwnership = this.ruleForm.TeamOwnership.toString();
      if (this.query.obj == null || this.query.obj == "") {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.RescourseTeamApi()
          .AddItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "救援队伍添加";
            this.logInfo.LogMessage = r ? "救援队伍添加成功" : "救援队伍添加失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "救援队伍管理详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.RescourseTeamApi()
          .UpdateItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.logInfo.ActionName = "救援队伍修改";
            this.logInfo.LogMessage = r ? "救援队伍修改成功" : "救援队伍修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "救援队伍管理详情页面";
            this.addOperationLog();
           this.$emit("ChangeTab", "second"); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>